<div class="aadhar-wrap">
  
  <div class="aadhar-input">
    <div class="col-3 form-group">
      <label class="form-label">Enter Aadhaar Number</label>
      <div class="input-with-icon text">
        <span class="input-text valid"  > <img *ngIf="currentApplicant?.aadhaarConfirmation" class="input-icon" src="assets/images/icons/verified_tick.svg" alt="Icon" /> <div *ngIf="showLoader" class="loader" ></div></span>

        <input class="cus-input" type="text" 
        [(ngModel)]="currentApplicant?.aadhaarConfirmation? currentApplicant.aadhaarInfo.maskedAdharNumber :aadhaarNo"
        (input)="this.otpForm.reset()" 
        (keypress)="onlyNumber($event)"  
        (input)="aadhaarNo.length === 12? onVerifyAadhar():''" 
        (keyup.enter)="onVerifyAadhar()"
        [disabled]="currentApplicant?.aadhaarConfirmation"
        placeholder="Enter number" minlength="12" maxlength="12"  />
        <span class="_end"> {{currentApplicant?.aadhaarConfirmation? 12 :(aadhaarNo || '').length?aadhaarNo.length:0 }}/12</span>
        

      </div>
    </div>
    <div class="col-3 form-group">
      <label class="form-label" *ngIf="!currentApplicant?.aadhaarConfirmation && requestId?.length !=0 && aadhaarNo?.length === 12">Enter Mobile OTP</label>
      <form class="otp-inputs" *ngIf="!currentApplicant?.aadhaarConfirmation && requestId?.length !=0 && aadhaarNo?.length === 12" [formGroup]="this.otpForm">
        <input class="cus-input first-input" type="text" formControlName="field1" maxlength="1"
          (keypress)="onlyNumber($event)" (keyup)="tabChange(1)" />
        <input class="cus-input" type="text" formControlName="field2" maxlength="1" (keypress)="onlyNumber($event)"
          (keyup)="tabChange(2)" />
        <input class="cus-input" type="text" formControlName="field3" maxlength="1" (keypress)="onlyNumber($event)"
          (keyup)="tabChange(3)" />
        <input class="cus-input" type="text" formControlName="field4" maxlength="1" (keypress)="onlyNumber($event)"
          (keyup)="tabChange(4)" />
        <input class="cus-input" type="text" formControlName="field5" maxlength="1" (keypress)="onlyNumber($event)"
          (keyup)="tabChange(5)" />
        <input class="cus-input" type="text" formControlName="field6" maxlength="1" (keypress)="onlyNumber($event)"
          (keyup)="tabChange(6)" />
      </form>
      <div class="danger" *ngIf="requestId?.length !=0 && aadhaarNo?.length === 12" >{{this.errMsg}}</div>
      <div class="resend-otp" *ngIf="requestId?.length !=0 && aadhaarNo?.length === 12 && resendTimer > 0" >Resend OTP in <span class="highlight">00:{{timerCount}}</span></div>
      <div class="resend-otp resend-link" *ngIf="!currentApplicant?.aadhaarConfirmation&&  requestId?.length !=0 && aadhaarNo?.length === 12 && resendTimer==0 && resendClickTimes <=3" (click)="reSend();">Resend</div>
      <div class="issues-text" *ngIf="resendClickTimes >1 || this.errMsg.length >0 &&!currentApplicant?.aadhaarConfirmation"><span class="wrap-text">Still Facing issues ?</span><span class="link"
        (click)="openDigiLocker()">Login with
        Digi-Locker</span></div>

    </div>

  </div>

  <!-- <div class="page-action">
    <button class="btn-primary" [disabled]="otpFormGroup.invalid" (click)="otpSubmit()">Continue</button>
  </div> -->
</div>
